module.exports = __webpack_public_path__ + "static/media/Change_Everything_You_Need.6940e5c6.svg";